import { render } from "./VenueUserAcquisition.vue?vue&type=template&id=7f268d0f&scoped=true"
import script from "./VenueUserAcquisition.vue?vue&type=script&lang=js"
export * from "./VenueUserAcquisition.vue?vue&type=script&lang=js"

import "./VenueUserAcquisition.vue?vue&type=style&index=0&id=7f268d0f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7f268d0f"

export default script